import React, { useEffect } from 'react';
import $ from 'jquery';

const SimpleDataTables = ({ columns, rows, button, buttonText, buttonOnClick, funcParam}) => {
    useEffect(() => {
        //initialize datatable
        if (!$.fn.dataTable.isDataTable('#datatable')) {
            $(document).ready(function () {
                setTimeout(function () {
                    $('#datatable').DataTable({
                        retrieve: true,
                        pageLength: 5,
                        lengthMenu: [[5, 10, 15, 20, 25, -1], [5, 10, 15, 20, 25, 'All']]
                    });
                }, 10);
            });
        }
    });
    console.log('rows', rows);
    
    return (
        <div className='table-responsive'>
            <table id="datatable" className="table table-hover">
                <thead>
                    <tr>
                        {columns && columns.map((col, i ) => (
                            <th key={i.toString()} scope="col">{col.label}</th>
                        ))}
                        {button ? (
                            <th  scope="col">Actions</th>
                        ) : null}
                    </tr>
                </thead>
                <tbody>
                    {rows && rows.map((row, i) => (
                        <tr key={i.toString()}>
                            {Object.values(row).map((value, i) => (
                                <td key={value + i + 1}>{value}</td>
                            ))}
                            {button ? (
                                <td>
                                    <button className='btn btn-sm btn-primary' onClick={(e) => buttonOnClick(
                                        e, 
                                        funcParam === 'customerId' ? row.customerId 
                                            : (funcParam === 'supplierId' ? row.supplierId 
                                                : (funcParam === 'row' ? row :''))
                                    )}>{buttonText}</button>
                                </td>
                            ) : null}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default SimpleDataTables;